export const personalizationMessages = [
  "Getting to know you better…",
  "Tailoring the content just for you…",
  "Sprinkling some personal magic on your lessons…",
  "Teaching Deep Thought about your goals…",
  "Customising examples to match your world…",
  "Making this course feel like it was written for you…",
  "Connecting the dots between theory and your reality…",
  "Infusing your context into every lesson…",
  "Crafting personalised insights…",
  "Aligning the curriculum with your ambitions…",
  "Adding a dash of you to each chapter…",
  "Translating concepts into your language…",
  "Building bridges between ideas and your experience…",
  "Fine-tuning the learning journey for you…",
  "Initiating the Infinite Improbability Drive…",
  "Fetching the Ultimate Answer to Life, the Universe, and Everything...yup, still 42",
  "Summoning the spirit of Steve Jobs for insights…",
  "Brewing a cup of tea for inspiration…",
  "Navigating through the hyperspace of knowledge…",
  "Scanning your brainwaves for telepathic answers…",
  "Brewing a potent potion of knowledge just for you…",
  "Decoding the secrets of the educational cosmos…",
  "Sifting through the sands of time for your perfect curriculum…",
  "Calibrating our crystal ball for peak educational foresight…",
  "Mixing the perfect blend of insight and enlightenment…",
  "Having a quick brainstorm with David Ogilvy…",
  "Asking for Rory Sutherland's take…",
];

export const isGeneratingPersonalization = (
  personalizationState?: string | null,
) => ["generating", "generating_progress"].includes(personalizationState || "");

export const nextPersonalizationProgress = (currentProgress: number) => {
  const randomIncrease = Math.floor(Math.random() * 8) + 10;

  return Math.min(currentProgress + randomIncrease, 95);
};

export const getRandomPersonalizationMessage = () => {
  const randomIndex = Math.floor(Math.random() * personalizationMessages.length);

  return personalizationMessages[randomIndex];
};
